<template>
  <div v-if="loading || !reportsBlank">
    <report-time-stat-graphs
      @color-update="colorUpdate($event)"
      :report="graphReport"
      :stats="query.graph.stats" 
      :fields="query.fields" 
      :interval="query.graph.interval"
      :joint-tooltip="true"
      :currently-viewed-report="currentlyViewedReport"
      :timezone="query.timezone">
    </report-time-stat-graphs>
    <report-table
      @page-change="pageChange($event)"
      :report="tableReport" 
      :stats="query.table.stats" 
      :fields="query.fields"
      :graph-colors="graphColors"
      :current-page="currentPage"
      :per-page="perPage"
      :synced-with-graph="true"
      ref="table">
    </report-table>
    <hr class="m-0 border-border" />
    <b-pagination 
      v-if="perPage > 0 && tableReport.length > 0" 
      class="mt-3"
      :total-rows="tableReport.length" 
      align="center" 
      v-model="currentPage"
      :per-page="perPage">
    </b-pagination>
  </div>
  <no-results v-else></no-results>
</template>

<script>
import ReportTimeStatGraphs from '@/reports/components/graphs/ReportTimeStatGraphs'
import ReportTable from '@/reports/components/ReportTable'
import { getPrettyStatName, getSuggestedInterval } from '@/reports/components/ReportUtils'
import { ReportsApi } from '@/reports/api'
import NoResults from '@/components/NoResults'

export default {
  props: {
    options: { type: Object, required: true }
  },
  data () {
    return {
      loading: true,
      currentPage: 0,
      perPage: 10,
      graphReport: [],
      tableReport: [],
      query: {
        fields: ['med_name'],
        dateAsMillis: true,
        graph: {
          interval: 'HOUR',
          stats: ['auctions', 'bids']
        },
        table: {
          stats: ['auctions', 'bids', 'clears']
        }
      },
      currentlyViewedReport: [],
      graphColors: {},
    }
  },
  created () {
    this.getNewReports()
  },
  methods: {
    pageChange (currentlyViewedReport) {
      this.currentlyViewedReport = currentlyViewedReport
    },
    colorUpdate (colors) {
      this.graphColors = colors
    },
    getNewReports () {
      this.loading = true
      Promise.all([
        this.getGraphReport(),
        this.getTableReport()
      ]).then(() => {
        this.loading = false
      })
    },
    getTableReport(tab) {
      return ReportsApi.bqreport(this.tableQuery, this).then((data) => {
        this.tableReport = data.results
      }, (e) => {
        console.error(e)
      })
    },
    getGraphReport(tab) {
      return ReportsApi.bqreport(this.graphQuery, this).then((data) => {
        this.graphReport = data.results
      }, (e) => {
        console.error(e)
      })
    },
  },
  computed: {
    reportsBlank () {
      return this.tableReport.length === 0 && this.graphReport.length === 0
    },
    tableQuery () {
      let query = JSON.parse(JSON.stringify(this.query))
      for (let option in query.table) {
        query[option] = query.table[option]
      }
      delete query.table
      delete query.graph 
      for (let option in this.options) {
        query[option] = this.options[option]
      }
      return query
    },
    graphQuery () {
      let query = JSON.parse(JSON.stringify(this.query))
      for (let option in query.graph) {
        query[option] = query.graph[option]
      }
      delete query.table
      delete query.graph 
      for (let option in this.options) {
        query[option] = this.options[option]
      }
      query.interval = getSuggestedInterval(query.startTime, query.endTime)
      return query
    }
  },
  watch: {
    options () {
      this.getNewReports()
    }
  },
  components: {
    ReportTimeStatGraphs,
    ReportTable,
    NoResults
  }
}
</script>


// WEBPACK FOOTER //
// src/reports/components/User/JourneyView.vue